import { createContext } from 'react';
import { FormFieldContextType } from './types';

export const FormFieldContext = createContext<FormFieldContextType>({
  dataKey: undefined,
  label: undefined,
} as unknown as FormFieldContextType);
